import styled from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';

export const StyledImage = styled(Image)`
  width: 100%;
`;

StyledImage.displayName = 'StyledImage';
